import * as angular from "angular";
import {User, CurrentUser} from "../../models/user.model";
import {ApiUrl} from "../../models/app-config.model";

interface UserResponse { data: User; }

export interface UserService {
    get: () => angular.IPromise<CurrentUser>;
    getNoCache: () => angular.IPromise<CurrentUser>;
}

/* @ngInject */
export function userService(API_URL: ApiUrl, $http: angular.IHttpService, $cacheFactory: angular.ICacheFactoryService): UserService {
    let userCache = $cacheFactory("userCache");
    return {
        get: () => {
            return $http.get(API_URL.user, { cache: userCache }).then((response: UserResponse) => {
                return new CurrentUser(response.data);
            });
        },
        getNoCache: () => {
            return $http.get(API_URL.user).then((response: UserResponse) => {
                return new CurrentUser(response.data);
            });
        }
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/services/user/user.service.ts